export default {
  labels: {
    radius: 'Säde',
  },
};
